// extracted by mini-css-extract-plugin
module.exports = {"guide_page":"GuidePage_guide_page__Wroh6"};